import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/** Oldal-tartalom konténer (a terv .page/.page-body mintája): max 1440px, középre, 24–28px padding. */
export function PageBody({
  children,
  className,
  align = 'center',
  tight = false,
}: {
  children: ReactNode;
  className?: string;
  /**
   * Vízszintes igazítás. `center` (alap): a tartalom a viewport közepén, `max-w-[1440px]`-en belül —
   * széles monitoron egyenlő margókkal. `left`: a tartalom a BAL szélhez igazodik, ugyanoda, ahol a
   * topbar morzsa-címe kezdődik (a `FormPage` mintája: `md:px-4`) — a mérés-/áttekintő-lapokon ez a helyes,
   * mert ott a felhasználó a bal széltől olvas, és a középre húzott blokk „lebegőnek" látszik (user-döntés).
   */
  align?: 'center' | 'left';
  /**
   * SZŰKEBB felső/alsó térköz (12px a 24px helyett) — az ÁTTEKINTÉS lapon kell: a lap nagy köszöntő-címmel
   * indul, és a bővebb közzel a tartalom teteje 11px-cel a sidebar első menüpontja ALÁ került (user-lelet;
   * mérve: nav-elem 73 · tartalom 84 → 12px-es közzel 72). Ugyanaz a döntés, mint a `FormPage`
   * `tight`-jánál.
   */
  tight?: boolean;
}): JSX.Element {
  return (
    <div
      className={cn(
        // A VÍZSZINTES igazítás mobilon is az app igazítási vonalán áll (`px-4` = 16px): ugyanott, ahol a
        // `ListToolbar`, a megszemélyesítés-sáv (`mx-4`) és a lista-lapok tartalma. A korábbi `p-5` (20px)
        // miatt a Pénzügy-lap csíkja és táblája 4px-cel beljebb ült, mint a FÖLÖTTE lévő eszköztár — mérve
        // 375px-en: tartalom 20 / eszköztár 16 (user-lelet). A FÜGGŐLEGES 20px marad.
        'w-full px-4 py-5',
        align === 'center' ? 'mx-auto max-w-[1440px] md:px-7' : 'md:px-4',
        tight ? 'md:py-3' : 'md:py-6',
        className,
      )}
    >
      {children}
    </div>
  );
}
